/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './admission-consultant.reducer';

export const AdmissionConsultantDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const admissionConsultantEntity = useAppSelector(state => state.admissionConsultant.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="admissionConsultantDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.admissionConsultant.detail.title">AdmissionConsultant</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.admissionConsultant.id">Id</Translate>
            </span>
          </dt>
          <dd>{admissionConsultantEntity.id}</dd>
          <dt>
            <span id="primary">
              <Translate contentKey="tinyMedicRestApp.admissionConsultant.primary">Primary</Translate>
            </span>
          </dt>
          <dd>{admissionConsultantEntity.primary ? 'true' : 'false'}</dd>
          <dt>
            <span id="billable">
              <Translate contentKey="tinyMedicRestApp.admissionConsultant.billable">Billable</Translate>
            </span>
          </dt>
          <dd>{admissionConsultantEntity.billable ? 'true' : 'false'}</dd>
          <dt>
            <span id="assignedOn">
              <Translate contentKey="tinyMedicRestApp.admissionConsultant.assignedOn">Assigned On</Translate>
            </span>
          </dt>
          <dd>{admissionConsultantEntity.assignedOn}</dd>
          <dt>
            <span id="ReleasedOn">
              <Translate contentKey="tinyMedicRestApp.admissionConsultant.ReleasedOn">Released On</Translate>
            </span>
          </dt>
          <dd>{admissionConsultantEntity.ReleasedOn}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.admissionConsultant.active">Active</Translate>
            </span>
          </dt>
          <dd>{admissionConsultantEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.admissionConsultant.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{admissionConsultantEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.admissionConsultant.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{admissionConsultantEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.admissionConsultant.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{admissionConsultantEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.admissionConsultant.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{admissionConsultantEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.admissionConsultant.consultant">Consultant</Translate>
          </dt>
          <dd>{admissionConsultantEntity.consultant ? admissionConsultantEntity.consultant.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.admissionConsultant.admission">Admission</Translate>
          </dt>
          <dd>{admissionConsultantEntity.admission ? admissionConsultantEntity.admission.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.admissionConsultant.specialty">Specialty</Translate>
          </dt>
          <dd>{admissionConsultantEntity.specialty ? admissionConsultantEntity.specialty.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/admission-consultant" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/admission-consultant/${admissionConsultantEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AdmissionConsultantDetail;
